// extracted by mini-css-extract-plugin
export default {"pageWrap":"ya-z","fullWidth":"za-z","heading":"Aa-z","fullBleed":"Ba-z","hidden":"Ca-z"};